import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';

import type { CreateProjectListingSuggestionPayload } from '@/api/v4/project-enhance-listing-suggestions.api';
import { createProjectListingSuggestions } from '@/api/v4/project-enhance-listing-suggestions.api';
import { notify } from '@/ui/snackbar/notify';
import { useProjectListingSuggestionState } from './use-project-listing-suggestion.state';

export const useCreateProjectListingSuggestions = (projectId?: string) => {
  const { t } = useTranslation('default');
  const state = useProjectListingSuggestionState();

  return useMutation({
    mutationFn: async (payload: CreateProjectListingSuggestionPayload) => {
      if (!projectId) {
        throw new Error('Project ID is required to create listing suggestions');
      }
      state.setCurrentPageStep('analyzing');
      return await createProjectListingSuggestions(projectId, payload);
    },
    onSuccess: data => {
      state.setEnhanceRequestId(data.requestId);
      state.setEnhanceResults(data.results);
      state.setCurrentPageStep('results');
    },
    onError: (error: Error) => {
      state.setCurrentPageStep('error');
      notify({
        message: t`unknownError`,
      });
      console.error(error.message);
    },
  });
};
